import gsap from 'gsap'
import {headerClass, menuClass, searchClass, colors, isAllMobileDevices} from './bundle'

let instance = null
class LoginPopup{
    constructor(){
        //Singleton
        if(instance){
            return instance
        }
        instance = this


        this.popupActions = document.querySelector('.popup-actions')
        this.allPopus = [...this.popupActions.querySelectorAll('.popup-actions__item')]
        this.popupActionsBackground = this.popupActions.querySelector('.popup-actions__bg')
        this.popupActionsOverlay = this.popupActions.querySelector('.overlay')

        this.headerLogin = document.querySelector('.action-user')
        this.userStatus = this.headerLogin.getAttribute('data-user-status')
        this.openPopupLoginBtns = [...document.querySelectorAll('.open-popup-login-btn')]
        this.loginPopup = document.querySelector('.login-popup')
        this.loginPopupWrapper = this.loginPopup.querySelector('.login-popup__wrapper')
        this.loginPopupForm = this.loginPopup.querySelector('.login-popup__form')
        this.closeLoginPopupBtns = [...this.popupActions.querySelectorAll('.close-login-popup-btn')]
        
        /**
         * MOBILE
         */
        this.containerMobileMenus = document.querySelector('.container-mobile-menus')

        //Bool
        this.isAnimating = false

        if(this.userStatus === 'non-loggato'){
            this.initEvents()
        }

    }

    initEvents() {
        this.openPopupLoginBtns.forEach(openBtn => {
            openBtn.addEventListener('click', () => {
                if (this.isAnimating) return
                this.isAnimating = true
                //chiudi popup login
                if (this.headerLogin.classList.contains('opened')) {
                    this.closeLoginPopup()

                    //Disattivato dopo che ho spostato l'header feed vino dentro all'header  
                    // if(document.querySelector('.page-single-product-vino') !== null){
                    //     headerClass.apriHeaderFeedVino()
                    // }
                }
                //apri popup login
                else {
                    //se ci sono altri popup aperti
                    if(document.querySelector('.popup-actions__item.popup-active') !== null){
                        const dataOtherPopup = document.querySelector('.popup-active').getAttribute('data-popup-element')
                        // console.log('chiudere prima il ', dataOtherPopup)
                        if(dataOtherPopup === 'menu'){
                            menuClass.closeMenu('login').then( () => {
                                this.openLoginPopup()
                            })
                        }
                        else if(dataOtherPopup === 'search'){
                            searchClass.closeSearch('login').then( () => {
                                this.openLoginPopup()
                            })
                        }
                    }
                    //Menu mobile aperto
                    else if(this.containerMobileMenus.classList.contains('menu-mobile-active')){
                        if(this.containerMobileMenus.querySelector('.submenu-mobile.opened') !== null){
                            menuClass.closeSubmenuMobile()
                        }
                        const fromAnotherEl = true
                        menuClass.closeMenuMobile(fromAnotherEl).then( () => {
                            this.openLoginPopup()
                        })
                    }
                    //se NON ci sono altri popup aperti
                    else{
                        // console.log('in teoria non ci sono altri popup aperti')
                        this.openLoginPopup()
                    }
                }
            })
        })
        this.closeLoginPopupBtns.forEach( closeBtn => {
            closeBtn.addEventListener('click', () => {
                this.closeLoginPopup()

                //Disattivato dopo che ho spostato l'header feed vino dentro all'header  
                // if(document.querySelector('.page-single-product-vino') !== null){
                //     headerClass.apriHeaderFeedVino()
                // }
            })
        })
    }

    setZindex(){
        gsap.set(this.loginPopup,{
            'z-index': 7
        })
        this.allPopus.forEach( popup => {
            if(!popup.isSameNode(this.loginPopup)){
                gsap.set(popup,{
                    'z-index': 3
                })
            }
        })
    }

    openLoginPopup() {
        if(isAllMobileDevices){
            document.body.style.overflow = 'hidden'
        }
        //update header elements color
        headerClass.toDefaultColor()
        this.setZindex()
        gsap.set(this.popupActions,{
            y: '0%'
        })
        let loginPopupWidth = this.loginPopupForm.getBoundingClientRect().width


        //Disattivato dopo che ho spostato l'header feed vino dentro all'header  
        // headerClass.chiudiHeaderFeedVino()

        gsap.to(this.popupActionsBackground,{
            duration: 0.4,
            opacity: 1
        })
        // gsap.to(this.popupActionsOverlay,{
        //     duration: 0.4,
        //     opacity: 1
        // })

        gsap.to(this.loginPopupWrapper, {
            duration: 0.8,
            width: loginPopupWidth,
            delay:0.2,
            ease: 'power2.inOut',
            onComplete: () => {
                this.isAnimating = false
            }
        })
        this.headerLogin.classList.add('opened')
        this.loginPopup.classList.add('popup-active')
    }

    closeLoginPopup(fromAnotherPopup = false) {
        return new Promise( resolve => {
            if(isAllMobileDevices){
                document.body.style.overflow = 'scroll'
            }
            this.headerLogin.classList.remove('opened')
            this.loginPopup.classList.remove('popup-active')
            gsap.to(this.loginPopupWrapper, {
                duration: 0.3,
                ease: 'power2.inOut',
                width: 0
            })
            if(!fromAnotherPopup){
                gsap.to(this.popupActionsBackground,{
                    duration: 0.3,
                    opacity: 0,
                    delay: 0.2,
                    onComplete: () => {
                        gsap.set(this.popupActions,{
                            y: '-100%'
                        })
                        gsap.set(this.popupActionsOverlay,{
                            opacity: 0
                        })
                        this.isAnimating = false
                        resolve()
                    }
                })
                //update header elements color
                const bgPageColor = getComputedStyle(document.querySelector('body')).backgroundColor
                if(bgPageColor === colors.panna){
                    headerClass.toAlternativeColor()
                }
                else{
                    headerClass.toDefaultColor()
                } 
            }
            else{
                // if(fromAnotherPopup === 'menu'){
                //     gsap.to(this.popupActionsOverlay,{
                //         duration: 0.3,
                //         opacity: 0,
                //         delay: 0.2,
                //         onComplete: () => {
                //             this.isAnimating = false
                //             resolve()
                //         }
                //     })
                // }
                // else{
                    this.isAnimating = false
                    resolve()
                // }
            }


        })

    }
}

export {LoginPopup}
